import { render, staticRenderFns } from "./FoundationStatistics.vue?vue&type=template&id=3b6151a8"
import script from "./FoundationStatistics.vue?vue&type=script&lang=js"
export * from "./FoundationStatistics.vue?vue&type=script&lang=js"
import style0 from "./FoundationStatistics.vue?vue&type=style&index=0&id=3b6151a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports